/*
eWorldES Proprietary Software
Copyright (C) 2025 eWorldES. All rights reserved.

This software is proprietary to eWorldES and is protected by copyright laws and international treaties.
You may not use, copy, modify, distribute, or disclose this software without explicit written permission from eWorldES.
Any unauthorized use or reproduction of this software is strictly prohibited and may result in legal action.

License Agreement:
By using this software, you agree to be bound by the terms of the eWorldES Proprietary Software License Agreement.
For a copy of the agreement, visit https://eworldes.com/ or contact eWorldES directly for more information.

This software is provided "AS IS" without warranty of any kind, express or implied, including but not limited to the warranties of
merchantability, fitness for a particular purpose, or non-infringement. In no event shall eWorldES be liable for any damages
arising out of the use of this software, even if eWorldES has been advised of the possibility of such damages.

For inquiries or requests regarding this software, please contact eWorldES at:
Email: info@eworldes.com
Website: https://eworldes.com/
*/

import React from "react";
import { Snackbar, Alert, Box, Typography } from "@mui/material";
import { AlertSeverity, BaseSnackbarProps } from "./TSnackBar";

const MUIAlert: React.FC<BaseSnackbarProps> = ({
  open,
  heading,
  message,
  statusCode,
  severity,
  autoHideDuration = 4000,
  position = { vertical: "top", horizontal: "center" },
  onClose,
}) => {
  const getSeverity = (
    statusCode?: number,
    severity?: AlertSeverity,
  ): AlertSeverity => {
    if (severity) return severity;

    if (!statusCode) return "info";

    const statusSeverityMap: Record<number, AlertSeverity> = {
      200: "success",
      201: "success",
      400: "warning",
      404: "warning",
      500: "error",
    };

    return statusSeverityMap[statusCode] || "info";
  };
  const alertSeverity = getSeverity(statusCode, severity);

  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      anchorOrigin={position}
      onClose={onClose}
    >
      <Alert
        onClose={onClose}
        severity={alertSeverity || "success"}
        sx={{
          display: "flex",
          alignItems: "start",
          minWidth: "380px",
          maxWidth: "584px",
          borderRadius: "8px",
          boxShadow:
            "0px 5px 22px 4px rgba(0, 0, 0, 0.12), 0px 12px 17px 2px rgba(0, 0, 0, 0.14), 0px 7px 8px -4px rgba(0, 0, 0, 0.20)",
          padding: "8px 16px",
        }}
      >
        <Box display="flex" flexDirection="column" flexGrow={1}>
          {heading && (
            <Typography fontWeight="bold" color="#1E4620">
              {heading}
            </Typography>
          )}
          <Typography fontSize="13px" color="black">
            {message}
          </Typography>
        </Box>
      </Alert>
    </Snackbar>
  );
};

export default MUIAlert;